import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {illustration, contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import email from "../../assets/lottie/email";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main contact-margin-top" id="contact">
        <div className="contact-div-main">
          <div className="contact-header">
            <h1 className="heading contact-title">{contactInfo.title}</h1>
            <p
              className={
                isDark
                  ? "dark-mode contact-subtitle"
                  : "subTitle contact-subtitle"
              }
            >
              {contactInfo.subtitle}
            </p>
            <div
              className={
                isDark ? "dark-mode contact-text-div" : "contact-text-div"
              }
            >
              {contactInfo.number && (
                <>
                  <a
                    className="contact-detail"
                    href={"tel:" + contactInfo.number}
                  >
                    {contactInfo.number}
                  </a>
                  <br />
                  <br />
                </>
              )}
              <a
                className="contact-detail-email"
                href={"mailto:" + contactInfo.email_address}
              >
                {contactInfo.email_address}
              </a>
              {contactInfo.wechat_official && (
                <>
                  <br />
                  <br />
                  <div
                    className="contact-detail-email"
                    style={{
                      fontSize: "0.85em",
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                      flexWrap: "wrap"
                    }}
                  >
                    <img
                      src={require("../../assets/images/wechatQR.jpg")}
                      alt="WeChat QR"
                      style={{
                        width: 120,
                        height: 120,
                        borderRadius: 8,
                        border: "1px solid #ddd",
                        cursor: "zoom-in",
                        flexShrink: 0
                      }}
                      onClick={e => {
                        const w = window.open("", "_blank");
                        w.document.write(
                          '<title>WeChat QR</title><body style="margin:0;background:#000;display:flex;align-items:center;justify-content:center;min-height:100vh"><img src="' +
                            e.target.src +
                            '" style="max-width:90vw;max-height:90vh"/></body>'
                        );
                      }}
                    />
                    <span style={{lineHeight: 1.6}}>
                      <i
                        className="fab fa-weixin"
                        style={{color: "#07c160", marginRight: 8}}
                      ></i>
                      微信扫码关注公众号
                      <br />
                      《{contactInfo.wechat_official}》 · 了解 AI 最新动态
                    </span>
                  </div>
                </>
              )}
              <br />
              <br />
              <SocialMedia />
            </div>
          </div>
          <div className="contact-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={email} />
            ) : (
              <img
                alt="Man working"
                src={require("../../assets/images/contactMailDark.svg")}
              ></img>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
